/**
 * Created by daniel on 16/04/17.
 */

import {combineReducers} from "redux";
import {config} from "./config/reducers";
import {ui} from "./ui/reducers";
import {content} from "./content/reducers";
import undoable, { includeAction } from 'redux-undo';
import * as actions from "./content/actions";

export const editor = combineReducers({
  content: undoable(content, {
    filter: includeAction([
      actions.CREATE_CONTENT_ITEM,
      actions.CREATE_CONTENT_ITEM,
      actions.DELETE_CONTENT_ITEM,
      actions.ORPHAN_CONTENT_ITEM,
      actions.RESTORE_ORPHANED_CONTENT_ITEM,
      actions.MOVE_CONTENT_ITEM,
      actions.UPDATE_CONTENT_ITEM,
      actions.HIDE_CONTENT_ITEM,
      actions.SET_CONTENT_ITEMS,
    ])
  }),
  ui,
  config,
});


// WEBPACK FOOTER //
// ./src/App/Editor/state/reducers.js